import { Tag } from "antd";
import type { HtmlHTMLAttributes } from "react";

export default function Status({
  style,
  title,
  className,
}: {
  style: "success" | "error" | "warning";
  title: React.ReactNode;
  className?: HtmlHTMLAttributes<HTMLDivElement>["className"];
}) {
  return (
    <Tag
      className={`rounded-full! py-1! px-3! text-14-regular! ${
        style === "success"
          ? "text-success-500! bg-success-50! border-success-200!"
          : style === "error"
            ? "text-error-500! bg-error-50! border-error-200!"
            : "text-warning-500! bg-warning-50! border-warning-200!"
      } ${className}`}
    >
      {title}
    </Tag>
  );
}
